import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import AppContext from "../context/AppContext";

export default function ShareOptions() {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const { shareoptions, showShareOptions } = useContext(AppContext);
    const [referredmy, setReferredmy] = useState(localStorage.getItem("referred_my") || false);
    const [selection, setSelection] = useState("random");


    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.classList.add('overflow-y-hidden');
        return () => {
            document.body.classList.remove('overflow-y-hidden');
        };
    }, []);


    const copyShared = (code, direction) => {
        navigator.clipboard.writeText(
            `${process.env.REACT_APP_FRONTEND}/signup?invite=${code}&direction=${direction}`
        );
        toast.success(t("_DASHBOARD._COPYMESSAGE"));
    };

    const closeShare = () => {
        showShareOptions(false);
    }

    const selectionShare = (item) => {
        if (item === "left") {
            copyShared(referredmy, "left")
        } else if (item === "right") {
            copyShared(referredmy, "right")
        } else {
            copyShared(referredmy, "random")
        }
        setSelection(item)
    }

    return (
        <>
            <div className="w-screen absolute h-full" style={{ zIndex: "100", backgroundColor: "#00000091" }}>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  custom-button-shadow-two rounded p-10 bg-zinc-800 w-11/12 lg:w-3/5">
                    <div className="flex justify-end cursor-pointer" onClick={() => closeShare()}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 text-blue-300 text-end">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </div>
                    <div className="flex flex-col w-full justify-center items-center">
                        <h2 className="text-white">{t("_DASHBOARD._TITLESHARED")}</h2>
                        <p className="text-white">{t("_DASHBOARD._TEXTSHARED")}</p>
                        <div className="flex flex-col lg:flex-row justify-around w-full gap-2 my-4">
                            <button className="shim-packages p-4 rounded-lg flex flex-justify items-center gap-2 opacity-80 hover:opacity-100" onClick={() => selectionShare("left")}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                                </svg>
                                <p>{t("_NETWORK._LEFT")}</p>
                            </button>
                            <button className="shim-packages p-4 rounded-lg flex flex-justify items-center gap-2 opacity-80 hover:opacity-100" onClick={() => selectionShare("random")}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                                </svg>
                                <p>{t("_DASHBOARD._RANDOM")}</p>
                            </button>
                            <button className="shim-packages p-4 rounded-lg flex flex-justify items-center gap-2 opacity-80 hover:opacity-100" onClick={() => selectionShare("right")}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                                </svg>
                                <p>{t("_NETWORK._RIGHT")}</p>
                            </button>
                        </div>
                        {referredmy && (
                            <span className="cursor-pointer bg-zinc-900 text-white font-medium p-1 rounded  border-zinc-700 border-2 w-full lg:w-auto flex flex-row gap-2 justify-center items-center" onClick={() => copyShared(referredmy, selection)}>
                                {process.env.REACT_APP_FRONTEND}/signup?invite={referredmy}&direction={selection}
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z" />
                                </svg>
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}
